import { render, staticRenderFns } from "./AccountReservations.vue?vue&type=template&id=4bc7cb12&scoped=true"
import script from "./AccountReservations.vue?vue&type=script&lang=js"
export * from "./AccountReservations.vue?vue&type=script&lang=js"
import style0 from "./AccountReservations.vue?vue&type=style&index=0&id=4bc7cb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7cb12",
  null
  
)

export default component.exports